export const isString = (value) => typeof value === 'string';

export const isBoolean = (value) => typeof value === 'boolean';

export const isObject = (value) => typeof value === 'object';

// eslint-disable-next-line no-prototype-builtins
export const has = (object, key) => isObject(object) && object.hasOwnProperty(key);

// eslint-disable-next-line no-confusing-arrow
export const get = (object, key, defaultValue) => (has(object, key) ? object[key] : defaultValue);

export const px = (value) => `${value}px`;

export const translate = (x, y) => `translate(${x}, ${y})`;

export const tryParseJson = (jsonString) => {
  try {
    return JSON.parse(jsonString);
  } catch (e) {
    return {};
  }
};
